import type { AppEnvironment } from './environment.types';

export const environment: AppEnvironment = {
  production: false,
  name: 'dev',
  appUrl: 'https://dev-runner.magalinb.com',
  apiBaseUrl: '',
  auth: {
    userPoolId: 'eu-central-1_IAI8GaJGe',
    userPoolClientId: '1ia7jbcnejsjh7ti5lfefuv6rm',
    domain: 'castor-dev-app.auth.eu-central-1.amazoncognito.com',
    redirectSignIn: ['https://dev-poc.magalinb.com/', 'https://dev-runner.magalinb.com/'],
    redirectSignOut: ['https://dev-poc.magalinb.com/', 'https://dev-runner.magalinb.com/'],
  },
};
